<template>
  <div>
    <div class="marginCenter">
      <div class="marginBom30 marginTop30 navTitle flex-yCenter flex-sb">
        <div class="left flex">
          <div class="line"></div>
          <span>进修考核</span>
        </div>
      </div>
      <div class="query marginBom24">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="进修记录">
            <el-select
              v-model="applyId"
              placeholder="请选择进修记录"
              style="width: 420px"
            >
              <el-option
                v-for="apply in applyList"
                :key="apply.applyId"
                :label="
                  selectDictLabel(dict.type.train_type, apply.trainType) +
                  '（' +
                  apply.applyBasic.trainBeginDate +
                  '~' +
                  apply.applyBasic.trainEndDate +
                  '）'
                "
                :value="apply.applyId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button
              class="fr blueBtn1"
              style="width: 140px; height: 40px"
              type="primary"
              @click="getTableData"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="fcolor_red marginBom24">请确保考核成绩及鉴定人签名已显示，如未显示：1️⃣确保科室进修负责人已填写成绩并已电子签名2️⃣重新点击“考核”，生成并打印带成绩及签名的考核表。</div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
        ref="table"
        :header-cell-style="{ backgroundColor: '#f5f5f5' }"
      >
        <el-table-column prop="type" label="进修类型" min-width="159" align="center">
          <span slot-scope="scope">{{
            dict.type.train_type.filter((item) => item.value == scope.row.trainType)[0]
              .label
          }}</span>
        </el-table-column>
        <el-table-column
          prop="applyBasic.trainBeginDate"
          label="进修申请时间"
          align="center"
          min-width="150"
        >
        </el-table-column>
        <!-- <el-table-column prop="leaveEstimateDate" label="离院时间" align="center" min-width="213">
        </el-table-column> -->
        <el-table-column
          label="进修科室"
          width="150"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.applyDeptList"
                :key="index"
              >
                <span>{{ item.deptName }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="进修周期时长" width="110" align="center">
          <template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.applyDeptList"
                :key="index"
              >
                <span>{{ item.trainDuration }}个月</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="进修考核表" align="center" min-width="213">
          <template slot-scope="scope">
            <div v-if="scope.row.applyBasic.trainAssessmentFlag == 1">
              <el-button
                type="text"
                @click="previewFile(scope.row.applyBasic.trainAssessmentAtt)"
                >查看</el-button
              >
              <el-button
                type="text"
                @click="
                  downLoadFile(
                    scope.row.applyBasic.trainAssessmentAtt,
                    `${scope.row.applyBasic.userName}进修考核表（${
                      dict.type.train_type.filter(
                        (item) => item.value == scope.row.trainType
                      )[0].label
                    }）`
                  )
                "
                >下载</el-button
              >
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="213">
          <div slot-scope="scope">
            <el-button
              v-if="scope.row.appraisalHospital && scope.row.leaveStatus == 0"
              type="text"
              @click="
                $router.push({
                  path:scope.row.trainType=='1'?'/examine/nursedetail': '/examine/detail',
                  query: { applyId: scope.row.applyId, trainAssessmentFlag: scope.row.applyBasic.trainAssessmentFlag },
                })
              "
              >考核</el-button
            >
          </div>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { downLoadFile } from "@/utils/myUtil";
import { trainApplySelectApplyList, trainApplyDetail } from "@/utils/api";
import { selectDictLabel } from "@/utils/ruoyi";
export default {
  components: {},
  dicts: ["train_type"],
  data() {
    return {
      params: {
        leaveProcFlag: 1,
        archivesStatus: 0,
        params: {},
        date: [],
      },
      applyId: undefined,
      applyList: [],
      tableData: [],
      loading: false,
    };
  },
  created() {
    this.getApplyList();
  },
  methods: {
    selectDictLabel,
    // 预览
    previewFile(src) {
      window.open(src + "?time=" + new Date().getTime());
    },
    // 下载
    downLoadFile(src, fileName) {
      downLoadFile(src, fileName);
    },
    getApplyList() {
      this.loading = true;
      trainApplySelectApplyList(this.params)
        .then((res) => {
          this.applyList = res.data;
          if (this.applyList.length > 0) {
            const applyId = this.$route.query.applyId;
            this.applyId = applyId ? applyId + "" : this.applyList[0].applyId;
            this.getTableData();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTableData() {
      if (!this.applyId) {
        return;
      }
      this.loading = true;
      trainApplyDetail(this.applyId)
        .then((res) => {
          console.log(123);
          this.tableData = [res.data];
          this.$nextTick(() => {
            this.$refs.table.doLayout();
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.query {
  padding: 20px;
  // height: 50px;
  background-color: #f5f5f5;

  .el-form-item {
    margin-bottom: 0;
  }

  .line {
    text-align: center;
  }
}

.col {
  color: #1890ff;
  cursor: pointer;
}

::v-deep .el-table .el-table__cell {
  padding: 0 !important;
}

::v-deep .el-table .cell {
  padding: 0 !important;
  line-height: 50px !important;
}

.myTable {
  justify-content: space-around;

  & > .myTable-td:not(:last-child) {
    border-bottom: 1px solid #ebeef5;
  }

  & > .myTable-td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
